// extracted by css-extract-rspack-plugin
export default {"modalHeader":"dB2A1qMdttse554K__modalHeader___","export":"EmuMzDE8GMkrsOB0__export___","modal":"VbkMUvmO6Tw_uuAQ__modal___","table":"rCLQjzfIkstranQC__table___"};